<!-- 流程审核操作 -->
<template>
  <div>
    <el-dialog :title="titleInfo" center :visible.sync="reviewDataBox" append-to-body >
      <el-form :model="sendDataInfo" label-position="top">
        <el-form-item label="审批结果">
          <el-radio-group v-model="sendDataInfo.auditState">
            <el-radio-button :label="1">同意</el-radio-button>
            <el-radio-button :label="0">不同意</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审批意见" prop="auditRemark" :rules="[{ required: auditRemarkRequired, message: '请输入审批意见', trigger: ['blur', 'change'] }]">
          <el-input type="textarea" placeholder="请输入内容" v-model="sendDataInfo.auditRemark" maxlength="200"
            show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reviewDataBox = false">取 消</el-button>
        <el-button type="primary" @click="submitDataAction()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="审核流程" center :visible.sync="reviewProcessBox" append-to-body top="2vh">
      <div class="reviewProcessBox">
        <el-timeline v-if="reviewNodeList.length > 0">
          <el-timeline-item v-for="(nodeValue, nodeKey) in reviewNodeList" :key="nodeKey"
            :timestamp="$common.getLocalTime(nodeValue.createTime,true)" placement="top" :icon="nodeValue.auditId == null ? 'el-icon-close': 'el-icon-check'" :type="nodeValue.auditId == null ? 'danger': 'success'">
            <el-card v-if="nodeKey == 0" >
              <h4>{{ nodeValue.appName }}</h4> 
              <p>发起人：{{ nodeValue.orderCreaterName }}</p>
            </el-card>
            <el-card v-else>
              <h4>{{ nodeValue.nodeName }}</h4>
              <p>操作人：{{ nodeValue.opmName }}</p>
              <p v-if="nodeValue.auditState != null" :class="nodeValue.auditState == 0 ? 'auditing_text_red ' : 'auditing_text_green'  ">
                操作状态：{{ nodeValue.auditState == 0 ? '审核驳回' : '审核通过' }}
              </p>
              <p>审核意见：{{ nodeValue.auditRemark ? nodeValue.auditRemark : '暂无信息' }}</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
        <div v-else style="text-align:center">暂无数据</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="reviewProcessBox = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
  name: "processAuditAction",
  // props:['formData'],
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
        titleInfo:'审核',
        auditRemarkRequired: window.global_config.auditRemarkRequired,
        reviewDataBox: false,
        reviewProcessBox: false,
      sendDataInfo: {
        auditState: 1,
        businessId: "",
        auditRemark: "",
      },
      reviewNodeList: [],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    dealTitle(val){
        this.titleInfo=val.taskName+'【'+val.businessId+'】审核'
    },
    openBox(cate, keyId = "") {
      if (cate == 0) {
        this.sendDataInfo.auditRemark = "";
        this.sendDataInfo.auditState = 1;
        if (typeof keyId == 'object') {
          console.log(1);
          this.sendDataInfo.businessId = keyId;
        } else {
          console.log(0);
          this.sendDataInfo.businessId = [keyId];
        }
        this.reviewDataBox = true;
      } else if(cate == 3){
   
         this.getTaskHistory(keyId);
      }
      else {
        this.getTaskReviewHistory(keyId);
      }
    },

    // 获取任务审核历史
    async getTaskReviewHistory(id) {
      let responseData = await this.$http.getTaskReviewHistory({
        ids: [id],
      });
      if (responseData.status == 200) {
        this.reviewProcessBox = true;
        this.reviewNodeList = responseData.result;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
      // 获取任务审核历史
    async getTaskHistory(id) {
      let responseData = await this.$http.auditModelHis({
        ids: [id],
        model:'return_record'
      });
      if (responseData.status == 200) {
        this.reviewProcessBox = true;
        this.reviewNodeList = responseData.result;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    // 提交审核
    async submitDataAction() {
      if (this.auditRemarkRequired && !this.sendDataInfo.auditRemark) {
        this.$message({
          message: "请输入审批意见",
          type: "warning",
        });
        return;
      }
      let responseData = await this.$http.addTaskReview(this.sendDataInfo);
      if (responseData.status == 200) {
        this.$message({
          type: "success",
          message: "操作成功",
        });

        this.reviewDataBox = false;
        this.$parent.getDataList();
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.dialog_content {
  height: 50vh;
  overflow-y: auto;
}
</style>